import { ConnectedAlertV3New } from "fleet/controller/alert-v3/connected-alert-v3-new";
import { ConnectedAlertV3Edit } from "fleet/controller/alert-v3/connected-edit";
import { ConnectedAlertsListPage } from "fleet/controller/alert-v3/connected-list";
import { ConnectedEventsV3List } from "fleet/controller/event-v3/connected-events-v3-list";
import { ConnectedIncidentsList } from "fleet/controller/incidents/connected-list";
import React from "react";
import { PrivateRoute } from "ui/private-route";
import { VIEW } from "view/views";

function renderDiagnosticRoutes() {
  return [
    <PrivateRoute
      exact
      path="/diagnostics"
      key="diagnostics-event"
      component={ConnectedEventsV3List}
    />,
    <PrivateRoute
      exact
      path="/diagnostics/incidents"
      key="diagnostics-incidents"
      component={ConnectedIncidentsList}
    />,
    <PrivateRoute
      exact
      path="/diagnostics/alerts"
      key="alert-list"
      component={ConnectedAlertsListPage}
    />,
    <PrivateRoute
      exact
      path={`/diagnostics/alerts/${VIEW.CREATE}`}
      key="alert-new"
      component={ConnectedAlertV3New}
    />,
    <PrivateRoute
      exact
      path={`/diagnostics/alerts/:id/${VIEW.EDIT}`}
      key="alert-edit"
      component={ConnectedAlertV3Edit}
    />,
  ];
}

export { renderDiagnosticRoutes };
